import { Injectable } from '@angular/core';
import {DataSourcesText} from "./data-sources-content/textStorage";

@Injectable({
  providedIn: 'root'
})
export class DataSourcesService {

  public dataSourcesText!: string[][]
  public activeButtons: string[] = []

  constructor() {
    this.dataSourcesText = Object.entries(DataSourcesText)
  }

  public updateActiveButton(buttonTitle: string): void {
    if (this.activeButtons.includes(buttonTitle)) {
      this.activeButtons.splice(this.activeButtons.indexOf(buttonTitle), 1)
    } else {
      this.activeButtons.push(buttonTitle)
    }
  }
}
